document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll(".wp-block-plblockstt-photo-gallery");

  wrappers.forEach((wrapper) => {
    const track = wrapper.querySelector(".photoGalleryInner");

    const items = () =>
      Array.from(
        wrapper.querySelectorAll(".wp-block-plblockstt-photo-gallery-slide")
      );

    const btnPrev = wrapper.querySelector(".photoGalleryNav .prev");
    const btnNext = wrapper.querySelector(".photoGalleryNav .next");

    if (!track) return;

    let index = Math.max(
      0,
      parseInt(wrapper.dataset.curEl || "1", 10) - 1
    );

    // ----- lock until transition finishes -----
    let locked = false;

    function lock() {
      locked = true;
    }

    function unlock() {
      locked = false;
    }

    function waitTransitionOnce(node) {
      return new Promise((resolve) => {
        const cs = getComputedStyle(node);
        const dur = parseFloat(cs.transitionDuration) || 0;

        if (dur === 0) {
          return requestAnimationFrame(resolve);
        }

        node.addEventListener("transitionend", resolve, { once: true });
      });
    }

    function clamp(i) {
      const max = Math.max(0, items().length - 1);
      return Math.max(0, Math.min(i, max));
    }

    function snapTo(i, { animate = true } = {}) {
      const list = items();

      index = clamp(i);

      const el = list[index];
      if (!el) return;

      wrapper.dataset.curEl = String(index + 1);

      if (!animate) {
        track.style.transition = "none";
      }

      const x = -el.offsetLeft;

      track.style.transform = `translate3d(${x}px, 0, 0)`;

      if (!animate) {
        requestAnimationFrame(() => {
          track.style.transition = "";
        });
      }

      if (btnPrev) {
        btnPrev.classList.toggle("hidden", index === 0);
      }

      if (btnNext) {
        btnNext.classList.toggle(
          "hidden",
          index === list.length - 1
        );
      }
    }

    async function go(delta) {
      if (locked) return;

      const list = items();
      if (!list.length) return;

      const nextIndex = clamp(index + delta);

      if (nextIndex === index) return;

      lock();

      snapTo(nextIndex, {
        animate: true
      });

      await waitTransitionOnce(track);

      unlock();
    }

    // Initial position
    snapTo(index, {
      animate: false
    });

    // Keep alignment correct on resize
    window.addEventListener("resize", () => {
      snapTo(index, {
        animate: false
      });
    });

    // Buttons
    btnPrev?.addEventListener("click", () => {
      go(-1);
    });

    btnNext?.addEventListener("click", () => {
      go(1);
    });

    // ----- swipe detection -----
    let startX = 0;
    let startY = 0;
    let startT = 0;

    let tracking = false;
    let pointerId = null;

    const THRESHOLD = 70;
    const ALLOWED_TIME = 700;
    const DIRECTION_RATIO = 1.5;

    wrapper.addEventListener(
      "pointerdown",
      (e) => {
        // Ignore navigation buttons
        if (e.target.closest(".photoGalleryNav")) return;

        if (locked) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        if (e.pointerType === "mouse" && e.button !== 0) return;

        tracking = true;
        pointerId = e.pointerId;

        startX = e.clientX;
        startY = e.clientY;
        startT = performance.now();

        wrapper.setPointerCapture?.(pointerId);
      },
      {
        passive: false
      }
    );

    wrapper.addEventListener(
      "pointermove",
      (e) => {
        if (!tracking || e.pointerId !== pointerId) return;

        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        if (
          Math.abs(dx) > 10 &&
          Math.abs(dx) > Math.abs(dy) * DIRECTION_RATIO
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      {
        passive: false
      }
    );

    wrapper.addEventListener(
      "pointerup",
      async (e) => {
        if (!tracking || e.pointerId !== pointerId) return;

        tracking = false;

        const dt = performance.now() - startT;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        const isSwipe =
          absX >= THRESHOLD &&
          absX > absY * DIRECTION_RATIO &&
          dt <= ALLOWED_TIME;

        if (!isSwipe) return;

        e.preventDefault();
        e.stopPropagation();

        if (dx < 0) {
          await go(1);
        } else {
          await go(-1);
        }
      },
      {
        passive: false
      }
    );

    wrapper.addEventListener(
      "pointercancel",
      () => {
        tracking = false;
      },
      {
        passive: false
      }
    );
  });
});